import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { VendorReturnDetailBus } from "./VendorReturnDetailBus";
import { CommonFunctions } from "../static/common-functions";

export class DispatchRefTrackingBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.refTrackDate = DateFunctions.getDate(this.refTrackDate);;
    }

    CID(): any {
        return this.dispatchRefTrackingId;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }

    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        if (!DateFunctions.isValidDate(this.refTrackDate)) {
            this.refTrackDate = this.insertDt;
        }
        if (!CommonFunctions.hasGuidValue(this.insertUserId)) {
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setFromForm(data: DispatchRefTrackingBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        this.updateUserId = data.insertUserId;
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.refTrackDate = DateFunctions.getDateTimeWithUTCOffset(this.refTrackDate);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    dispatchRefTrackingId: any;
    dispatchId: any;
    refTrackNbr: string;
    refTrackDate: Date;
    isComplete: boolean;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    person: string;
}